import {includes} from 'lodash';
import React, {useMemo} from 'react';
import {Redirect, useLocation, useParams} from 'react-router-dom';
import {isSessionParticipantsListEnabled} from '../../../../data/filters/schedule/isSessionParticipantsListEnabled';
import {useEvent} from '../../../../data/hooks/eventHooks';
import {useEventSettings} from '../../../../data/hooks/events/useEventSettings';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import {useEventParticipants} from '../../../../data/hooks/participant/useEventParticipants';
import {useProgramSession} from '../../../../data/hooks/schedule/useProgramSession';
import resolvePath from '../../../../misc/resolvePath';
import Blocklink from '../../../elements/Blocklink/Blocklink';
import {AlphabeticalParticipantsList} from '../../../elements/ParticipantsList';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Screen from '../../Screen';

class EventScheduleItemParticipantsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            busy: false,
        };
    }
    render() {
        let {i18n, event, programItem} = this.props;

        let header = (
            <div>
                <TopBarEvent event={event} returnURL="..">
                    {i18n['label.participants']}
                </TopBarEvent>
                <hr />
                <Blocklink customColor={event.settings.primary_color}>{programItem.name}</Blocklink>
                <hr />
            </div>
        );

        return (
            <Screen header={header}>
                <AlphabeticalParticipantsList
                    event={this.props.event}
                    participants={this.props.participants}
                    savePosition={'programSessionParticipants-' + programItem.id + '-' + this.props.eventId}
                    myUserId={this.props.myUserId}
                />
            </Screen>
        );
    }
}

export default props => {
    const {eventId, itemId} = useParams(),
        event = useEvent(eventId),
        settings = useEventSettings(eventId),
        programItem = useProgramSession(eventId, itemId),
        i18n = useI18n(),
        allParticipants = useEventParticipants(eventId),
        participants = useMemo(
            () => allParticipants.filter(participant => includes(participant.program_selection, programItem.id)),
            [allParticipants, programItem]
        ),
        {pathname} = useLocation(),
        fallbackRoute = resolvePath(pathname, '..'),
        fallback = !programItem || settings.disable_schedule || !isSessionParticipantsListEnabled(programItem, settings) || !programItem.is_selectable;

    if (fallback) {
        return <Redirect to={fallbackRoute} />;
    }

    return (
        <EventScheduleItemParticipantsScreen
            eventId={eventId}
            itemId={itemId}
            event={event}
            programItem={programItem}
            i18n={i18n}
            participants={participants}
        />
    );
};
